module.exports = __webpack_public_path__ + "img/7.9b926b18.png";